function formatDate(
  start_date?: string | null,
  end_date?: string | null,
  language: "en" | "ro" = "en"
): string {
  if (!start_date)
    return language === "ro" ? "nu există data" : "No date available";

  const monthsInRomanian = [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie",
  ];

  const monthsInEnglish = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const parseDate = (date: string, language: "en" | "ro") => {
    try {
      const parsedDate = new Date(date);

      // Check if parsedDate is invalid
      if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", date);
        return language === "ro" ? "nu există data" : "No date available";
      }

      const day = parsedDate.getDate(); // Get local date
      const month = parsedDate.getMonth(); // Month index (0-11)
      const year = parsedDate.getFullYear(); // Get local year

      const monthName =
        language === "ro" ? monthsInRomanian[month] : monthsInEnglish[month];

      return `${day} ${monthName} ${year}`;
    } catch (error) {
      console.error("Error parsing date:", date, error);
      return language === "ro" ? "nu există data" : "No date available";
    }
  };

  const formattedStartDate = parseDate(start_date, language);
  const formattedEndDate = end_date ? parseDate(end_date, language) : "";

  return formattedEndDate
    ? `${formattedStartDate} - ${formattedEndDate}`
    : formattedStartDate;
}

export default formatDate;
